import React, {Component} from "react"
import { Navigate } from "react-router-dom";

class SetTokenView extends Component {
    constructor(match) {
        super();

        const url = new URL(window.location.href);
        const token = url.searchParams.get("token");
        this.state = {
            token: token || null,
        };
    }
    
    componentDidMount() {
        if (this.state.token != null) {
            window.localStorage.setItem('token', this.state.token);
            window.localStorage.setItem('notifications', "granted");
        }
    }
    
    render() {
        return <Navigate to='/' replace />
    }
}

export default SetTokenView